import axios from 'axios';

const BASE = '/api/v1/mec';

export const mecApi = {
  getPeople: () => axios.get(`${BASE}/people`).then((response) => response.data),
  getChecklist: (period) => axios.get(`${BASE}/close/${period}`).then((response) => response.data),
  runGate: (period, gateKey) => axios.post(`${BASE}/runs`, { period, gate_key: gateKey }).then((response) => response.data),
  getRun: (runId) => axios.get(`${BASE}/runs/${runId}`).then((response) => response.data),
  getRunHistory: (period) => axios.get(`${BASE}/close/${period}/runs`).then((response) => response.data),
  getEvidence: (runId, params) => axios.get(`${BASE}/runs/${runId}/evidence`, { params }).then((response) => response.data),
  evidenceCsvUrl: (runId, params = {}) => {
    const query = new URLSearchParams(params).toString();
    return `${BASE}/runs/${runId}/evidence.csv${query ? `?${query}` : ''}`;
  },
  getPolicies: () => axios.get(`${BASE}/policies`).then((response) => response.data),
  proposePolicy: (payload) => axios.post(`${BASE}/policies`, payload).then((response) => response.data),
  approvePolicy: (policyId, note) => axios.post(`${BASE}/policies/${policyId}/approve`, { note }).then((response) => response.data),
  decideRun: (runId, action, note) => axios.post(`${BASE}/runs/${runId}/decision`, { action, note }).then((response) => response.data),
  updateException: (exceptionId, payload) => axios.patch(`${BASE}/exceptions/${exceptionId}`, payload).then((response) => response.data),
  getBankLinks: () => axios.get(`${BASE}/bank-links`).then((response) => response.data),
  mutateBankLink: (payload) => axios.post(`${BASE}/bank-links`, payload).then((response) => response.data),
  getAccountRoles: () => axios.get(`${BASE}/account-roles`).then((response) => response.data),
  mutateAccountRole: (payload) => axios.post(`${BASE}/account-roles`, payload).then((response) => response.data),
  getSnapshots: (period) => axios.get(`${BASE}/close/${period}/snapshots`).then((response) => response.data),
  createSnapshot: (period) => axios.post(`${BASE}/close/${period}/snapshots`).then((response) => response.data),
  getJeDrafts: (period) => axios.get(`${BASE}/close/${period}/je-drafts`).then((response) => response.data),
  getJeCoverage: (period) => axios.get(`${BASE}/je/${period}/coverage`).then((response) => response.data),
  getJeDraftDetail: (period, draftId) => axios.get(`${BASE}/close/${period}/je-drafts/${draftId}`).then((response) => response.data),
  getJePosting: (period, draftId) => axios.get(`${BASE}/close/${period}/je-drafts/${draftId}/posting`).then((response) => response.data),
  getEvidenceSchemas: () => axios.get(`${BASE}/evidence-schemas`).then((response) => response.data),
  getEvidenceImports: (period) => axios.get(`${BASE}/close/${period}/evidence-imports`).then((response) => response.data),
  getSourceLinks: (period) => axios.get(`${BASE}/close/${period}/source-links`).then((response) => response.data),
  setSourceLink: (period, sourceKey, payload) => axios.put(
    `${BASE}/close/${period}/source-links/${sourceKey}`,
    payload,
  ).then((response) => response.data),
  checkSourceLink: (period, sourceKey) => axios.post(
    `${BASE}/close/${period}/source-links/${sourceKey}/check`,
  ).then((response) => response.data),
  getEvidenceImport: (period, importId) => axios.get(`${BASE}/close/${period}/evidence-imports/${importId}`).then((response) => response.data),
  uploadEvidenceImport: (period, evidenceKey, { file, source_reference, control_total }) => {
    const formData = new FormData();
    formData.append('file', file);
    if (source_reference) formData.append('source_reference', source_reference);
    if (control_total !== undefined && control_total !== null && control_total !== '') {
      formData.append('control_total', control_total);
    }
    return axios.post(`${BASE}/close/${period}/evidence-imports/${evidenceKey}`, formData)
      .then((response) => response.data);
  },
  approveEvidenceImport: (period, importId, note) => axios.post(
    `${BASE}/close/${period}/evidence-imports/${importId}/approve`,
    { note },
  ).then((response) => response.data),
  postJeDraft: (period, draftId) => axios.post(`${BASE}/close/${period}/je-drafts/${draftId}/post`).then((response) => response.data),
  reconcileJePosting: (period, draftId) => axios.post(`${BASE}/close/${period}/je-drafts/${draftId}/posting/reconcile`).then((response) => response.data),
  generateJeDrafts: (period) => axios.post(`${BASE}/close/${period}/je-drafts/generate`).then((response) => response.data),
  submitJeDraft: (period, draftId) => axios.post(`${BASE}/close/${period}/je-drafts/${draftId}/submit`).then((response) => response.data),
  decideJeDraft: (period, draftId, action, note) => axios.post(`${BASE}/close/${period}/je-drafts/${draftId}/decision`, { action, note }).then((response) => response.data),
  jeDraftExportUrl: (period, draftId) => `${BASE}/close/${period}/je-drafts/${draftId}/export.csv`,
  getCertification: (period) => axios.get(`${BASE}/close/${period}/certification`).then((response) => response.data),
  certifyClose: (period, snapshotVersion, note) => axios.post(`${BASE}/close/${period}/certify`, { snapshot_version: snapshotVersion, note }).then((response) => response.data),
  snapshotUrl: (period, version) => `${BASE}/close/${period}/snapshots/${version}.pdf`,
};
